import React from 'react'

import classnames from 'classnames'

import { t } from 'src/translations'

import { useCheckout } from 'public/components/online_ordering/CheckoutContext'
import { usePayment } from 'public/components/online_ordering/PaymentContext'
import { ToastPaymentType } from 'public/components/online_ordering/types'

import Warning from 'shared/components/common/warning/Warning'
import { useFormContext } from 'react-hook-form'

export const SubmitButton = ({
  dataTestid,
  label,
  onClick,
  disabled
}: {
  dataTestid: string
  label: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
}) => {
  const { showTipWarning } = useCheckout()

  return (
    <>
      <button
        data-testid={dataTestid}
        type='submit'
        className={classnames('submitButton primaryCta')}
        onClick={onClick}
        disabled={disabled}
      >
        {label}
      </button>
      {showTipWarning && (
        <Warning
          dataTestId='place-order-tip-warning'
          message={t(
            'place-order-tip-warning.please-add-another-payment-method-for-tip'
          )}
        />
      )}
    </>
  )
}

const SubmitOrderButton = ({ disabled }: { disabled?: boolean }) => {
  const { paymentType } = usePayment()
  const { orderTotal } = useCheckout()
  const { formState } = useFormContext()

  if (paymentType === ToastPaymentType.APPLE_PAY && orderTotal > 0) {
    return (
      <button
        data-testid='applePaySubmitButton'
        type='submit'
        className='submitButton applePayBtn'
        disabled={disabled ?? formState.isSubmitting}
      />
    )
  }

  return (
    <SubmitButton
      dataTestid='basicSubmitButton'
      label={t('submit-order-button.place-order')}
      disabled={disabled ?? formState.isSubmitting}
    />
  )
}

export default SubmitOrderButton
